import { connect } from 'react-redux';

function setInvoiceSummary (invoice_summary) {
  return (dispatch) => {
    dispatch({type: 'SET_INVOICE_SUMMARY', invoice_summary});
  } 
}

function mapStateToProps (state) {
  return {...state, invoice_summary: state.InvoicesSummary?.invoice_summary};
}

const actionCreators = {
  SetInvoiceSummary: setInvoiceSummary
}

export function injectInvoicesStore () {
  return connect(mapStateToProps, actionCreators);
}